import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import {connect} from 'react-redux';
import {Redirect, Link} from 'react-router-dom';
import ReopenApplicationModal from 'go/components/modules/application/ReopenApplicationModal';
import CancelCloseoutReportModal from 'go/components/modules/application/CancelCloseoutReportModal';
import CreateEntityActionButton from 'go/components/dynamic/modules/grantLandingPage/CreateEntityActionButton';
import InitiateCloseoutReportModal from 'go/components/modules/application/InitiateCloseoutReportModal';
import InitiateSubCloseoutReportModal from 'go/components/modules/application/InitiateSubCloseoutReportModal';
import CancelSubCloseoutReportModal from 'go/components/modules/application/CancelSubCloseoutReportModal';
import REST from 'go/requests/rest';
import {Card, Header, Grid, Message} from 'semantic-ui-react';
import {Alert} from 'componentLibrary';
import {
  formatDateMMDDYYYY,
  getGrantActions,
  ISOToDisplayDate,
  retrieveAllEntityIdsFromPermissions,
} from 'common/utils';
import {
  STATUS_SUBMITTED_TO_FEMA,
  STATUS_NOT_SUBMITTED,
  STATUS_AWARD_OFFERED,
  PREAWARD_STATUSES,
  STATUS_PENDING_SUBMISSION,
  ASSOCIATED_ENTITY_STATUSES,
  STATUS_PENDING_AOR_SIGNATURE,
  ROLE_MAP,
  STATUS_INELIGIBLE,
  ENTITY_MAP,
  STATUS_RETURNED_TO_RECIPIENT,
} from 'app-ui-componentlibrary/dist/common/constants';
import GenericDisplayCard from 'app-ui-componentlibrary/dist/go/components/common/genericCard/genericDisplayCard';
import {
  canViewPostAwardEntities,
  canViewAndContinueSubapplication,
} from 'go/security/permissions';
import PermissionsUtility from 'go/security/permissionsUtility';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';

const GRANTS_CONFIG_PATHS = {
  GRANT_LINKS: 'grantIdLinks',
  PERIOD_PERFORMANCE_HEADER: 'periodOfPerformanceHeader',
  PERIOD_PERFORMANCE: 'periodOfPerformance',
  MODIFIED_STATUS: 'modifiedStatus',
  MODIFIED_STATUS_DATE: 'modifiedStatusDate',
  ACCEPTANCE_DEADLINE_HEADER: 'acceptanceDeadLineHeader',
  MODIFIED_ACCEPTANCE_DEADLINE: 'modifiedAcceptanceDeadLine',
};
export class GrantsFilterResults extends React.Component {
  state = {
    link: '',
    redirect: false,
    reopenModalOpen: false,
    cancelCloseoutReportModalOpen: false,
    selectedEntity: {},
    errors: {},
    initiateCloseoutReportModalOpen: false,
    initiateSubCloseoutReportModalOpen: false,
    cancelSubCloseoutReportModalOpen: false,
    selectedEntityType: {},
    amendments: [],
  };

  onError = (errors) => {
    this.setState({errors: errors});
  };

  isGrantWriterUser = (grantWriterEntityIds, grant) => {
    let hideLinks = false;
    _.forEach(grantWriterEntityIds, (idObj) => {
      const {hideOrgId, hideProgramId, hideSubOrgId} = idObj;
      hideLinks =
        hideLinks ||
        (grant.organizationId === hideOrgId &&
          grant.programId === hideProgramId &&
          grant.subOrgId === hideSubOrgId);
    });
    return hideLinks;
  };

  handleInitiateCloseoutReport = () => {
    this.setState({initiateCloseoutReportModalOpen: false});
  };

  handleCancelInitiateSubCloseoutReport = () => {
    this.setState({initiateSubCloseoutReportModalOpen: false});
  };

  showInitiateCloseoutReportModal = (entity, entityType) => {
    this.setState({
      selectedEntity: entity,
      selectedEntityType: entityType,
      initiateCloseoutReportModalOpen: true,
    });
  };

  showInitiateSubCloseoutReportModal = (entity, entityType) => {
    this.setState({
      selectedEntity: entity,
      selectedEntityType: entityType,
      initiateSubCloseoutReportModalOpen: true,
    });
  };

  conditionallyAddCell = (
    titleList,
    titleObj,
    contentList,
    content,
    shouldDisplayRules,
    context
  ) => {
    const {title, titleDataPath} = titleObj;

    if (
      shouldDisplay(undefined, undefined, shouldDisplayRules, context) ||
      !shouldDisplayRules
    ) {
      titleList.push(titleDataPath ? _.get(context, titleDataPath) : title);
      contentList.push(content);
    }
  };

  renderSections = (config, grant, grantWriterEntityIds, actions) => {
    let firstSectionTitles = [];
    let firstSectionWidth;
    let secondSectionWidth;
    let sectionSectionNoOfColumn;
    let thirdSectionWidth;
    let firstSectionContents = [];
    let secondSectionTitles = [];
    let secondSectionContents = [];

    const isGrantWriter = this.isGrantWriterUser(grantWriterEntityIds, grant);

    const context = {
      entity: grant,
    };

    // Custom Closeout Message is hardcoded for passthrough/BRIC-FMA-FY20-22.
    // Currently dont have configuration capability for grants filter page.
    let customCloseoutMessage;
    if (
      grant.payload.programType === 'passthrough' ||
      grant.programId === '14' ||
      grant.programId === '15'
    ) {
      customCloseoutMessage =
        'Before initiating closeout, you should complete all post-award activities and be ready to enter the closeout phase. If you need prior approval from FEMA on any outstanding issues, please submit an amendment request prior to initiating closeout. You will be able to return to the post-award phase if necessary to re-enable the FEMA GO payment and amendment features, but you will lose any work you have performed on your closeout report.';
    }
    if (config) {
      _.forEach(config.contents.grid.gridContents, (contents) => {
        firstSectionWidth = contents.identifier.width;
        secondSectionWidth = contents.details.width;
        thirdSectionWidth = contents.actions.width;

        // first column <- identifier key
        _.forEach(contents.identifier.rows, (cell) => {
          let value = _.get(grant, cell.dataPath);

          if (cell.title === 'GRANT ID' && isGrantWriter) {
            value = _.get(grant, 'grantId');
          }

          const title = {title: cell.title, titleDataPath: cell.titleDataPath};

          this.conditionallyAddCell(
            firstSectionTitles,
            title,
            firstSectionContents,
            value,
            cell.shouldDisplayRules,
            context
          );
        });

        // second column <- details key
        _.forEach(contents.details.rows, (rows) => {
          sectionSectionNoOfColumn = contents.details.noOfColumns;
          _.forEach(rows, (cell) => {
            const value = _.get(grant, cell.dataPath);
            const title = {title: cell.title, titleDataPath: cell.titleDataPath};
            this.conditionallyAddCell(
              secondSectionTitles,
              title,
              secondSectionContents,
              value,
              cell.shouldDisplayRules,
              context
            );
          });
        });
      });
    }

    return (
      <GenericDisplayCard
        id="generic-display-card"
        firstSectionTitles={firstSectionTitles}
        firstSectionContents={firstSectionContents}
        firstSectionWidth={firstSectionWidth}
        middleSectionTitles={secondSectionTitles}
        middleSectionContents={secondSectionContents}
        middleSectionWidth={secondSectionWidth}
        middleSectionColumns={sectionSectionNoOfColumn}
        lastSectionWidth={thirdSectionWidth}
      >
        {actions.length > 0 ? (
          <Header className="generic-card-row --header">I want to...</Header>
        ) : null}
        <CreateEntityActionButton
          showInitiateCloseoutReportModal={this.showInitiateCloseoutReportModal}
          showInitiateSubCloseoutReportModal={this.showInitiateSubCloseoutReportModal}
          showReopenModal={this.showReopenModal}
          showCancelCloseoutReportModal={this.showCancelCloseoutReportModal}
          showCancelSubCloseoutReportModal={this.showCancelSubCloseoutReportModal}
          token={this.props.token}
          permissions={this.props.permissions}
          grantId={_.get(grant, 'grantId')}
          subGrantId={_.get(grant, 'subGrantId')}
          entityId={_.get(grant, 'entityId')}
          entityType={_.get(grant, 'entityType')}
          actions={actions}
          onError={this.onError}
        />
        {!_.isEmpty(this.state.errors)
          ? this.displayErrorMessage(_.get(grant, 'grantId'))
          : null}
        <ReopenApplicationModal
          open={this.state.reopenModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          onCancel={this.handleCancel}
        />
        <InitiateCloseoutReportModal
          open={this.state.initiateCloseoutReportModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          entityType={this.state.selectedEntityType}
          onCancel={this.handleInitiateCloseoutReport}
          customCloseoutMessage={customCloseoutMessage}
        />
        <InitiateSubCloseoutReportModal
          open={this.state.initiateSubCloseoutReportModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          entityType={this.state.selectedEntityType}
          onCancel={this.handleCancelInitiateSubCloseoutReport}
        />
        <CancelCloseoutReportModal
          open={this.state.cancelCloseoutReportModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          onCancel={this.handleCancelCloseoutReport}
        />
        <CancelSubCloseoutReportModal
          open={this.state.cancelSubCloseoutReportModalOpen}
          entity={this.state.selectedEntity}
          token={this.props.token}
          onCancel={this.handleCancelSubCloseoutReport}
        />
      </GenericDisplayCard>
    );
  };

  displayErrorMessage = (grantId) => {
    let {errors} = this.state;
    if (grantId && !_.isEmpty(errors)) {
      let errorMessage =
        _.get(errors, 'grantId') == grantId ? (
          <Message
            error
            onDismiss={() => {
              this.setState({errors: null});
            }}
          >
            {_.get(errors, 'errors')}
          </Message>
        ) : null;
      return errorMessage;
    }
  };

  handleCancel = () => {
    this.setState({reopenModalOpen: false});
  };

  showReopenModal = (entity) => {
    this.setState({
      selectedEntity: entity,
      reopenModalOpen: true,
    });
  };

  handleCancelCloseoutReport = () => {
    this.setState({cancelCloseoutReportModalOpen: false});
  };

  showCancelCloseoutReportModal = (entity) => {
    this.setState({
      selectedEntity: entity,
      cancelCloseoutReportModalOpen: true,
    });
  };

  handleCancelSubCloseoutReport = () => {
    this.setState({cancelSubCloseoutReportModalOpen: false});
  };

  showCancelSubCloseoutReportModal = (entity) => {
    this.setState({
      selectedEntity: entity,
      cancelSubCloseoutReportModalOpen: true,
    });
  };

  checkForPendingSubGrantAmendments = async (foData, grant) => {
    let inprogressSubAmendments = false;
    const grantFoID = _.get(grant, 'fundingOpportunityId');
    const grantFoData = _.find(foData, {fundingOpportunityId: _.toNumber(grantFoID)});
    const allowRecipientToAmendSubSection = _.get(
      grantFoData,
      'configData.foOverview.allowRecipientToAmendSubSection',
      false
    );
    if (allowRecipientToAmendSubSection) {
      let subGrantAmendmentsStatus = [];
      await REST.dynamicData
        .getBySubGrantIdAndEntityType(
          this.props.token,
          grant.subGrantId,
          'subAmendmentRecommendation'
        )
        .then(REST.handler.handleResponse)
        .then((data) => {
          _.map(data, (amendment) => {
            subGrantAmendmentsStatus.push(amendment.status);
          });
          inprogressSubAmendments =
            _.includes(subGrantAmendmentsStatus, STATUS_PENDING_SUBMISSION) ||
            _.includes(subGrantAmendmentsStatus, STATUS_SUBMITTED_TO_FEMA) ||
            _.includes(subGrantAmendmentsStatus, STATUS_RETURNED_TO_RECIPIENT);
        })
        .catch((err) => {
          console.error(
            'error fetching subgrant amendments for subGrantId=' + grant.subGrantId
          );
        });
    }
    return inprogressSubAmendments;
  };

  renderCards(grants) {
    const {
      permissions,
      toggles,
      grantConfigs,
      subGrantConfigs,
      refItems,
      subOrganizationsDetails,
      grantAppExt,
      grantWriterEntityIds,
      currentOrg,
      token,
      pageEntityType,
      foData,
      amendments,
    } = this.props;
    let rolesToCheck = null;
    let toastHeader = '';

    if (pageEntityType === 'subgrant') {
      rolesToCheck = [ROLE_MAP.SUBAUTHREP.code];
      toastHeader = 'No Subapplications Found';
    }
    if (pageEntityType === 'grant') {
      rolesToCheck = [ROLE_MAP.SUBAUTHREP.code, ROLE_MAP.SUBMEMBER.code];
      toastHeader = 'No Grants Found';
    }

    const permissionUtil = new PermissionsUtility(token);
    const hasOrgSubOrgRelationshipForEntitySix = permissionUtil.isCurrentIdExistForEntitySix(
      currentOrg.entityId,
      token
    );

    if (grants && grants.length) {
      if (subOrganizationsDetails) {
        _.map(grants, (grant) => {
          if (grant.entityType === 'subApplication' || grant.entityType === 'subGrant') {
            var name = _.filter(subOrganizationsDetails, function (o) {
              return o.entityId == grant.subOrgId;
            });
            grant.subOrgDisplayName = _.get(name, '0.displayName', null);
          }
        });
      }

      return _.map(grants, (grant) => {
        if (
          refItems &&
          (grant.entityType === 'subApplication' || grant.entityType === 'subGrant')
        ) {
          var type = _.filter(refItems.APPLICATION_TYPE, function (o) {
            return o.id == grant.payload.applicationType
              ? grant.payload.applicationType
              : null;
          });
          grant.applicationType = type[0].displayText;
        }

        let statusDate = ISOToDisplayDate(grant.statusTimestamp, {
          showDate: true,
        });

        //If no subgrant id on sub entities, set blank.
        let grantId;
        let grantType;
        let manageGrantText;
        let config;
        switch (grant.entityType) {
          case 'subApplication':
          case 'subGrant':
            grantId = grant.subGrantId;
            grantType = 'subgrant';
            manageGrantText = grantId ? '(manage subgrant)' : '';
            config = subGrantConfigs[grant.categoryId || grant.fundingOpportunityId];
            break;
          case 'grant':
            grantId = grant.grantId;
            grantType = 'grant';
            manageGrantText = grantId ? '(manage grant)' : '';
            config = grantConfigs[grant.fundingOpportunityId];
            break;
          default:
            console.error('Unexpected entity type.');
        }

        let grantActions = config ? config.contents.grantActions : [];
        let appExtension;
        appExtension = _.find(grantAppExt, {grantId: grant.grantId});

        const permissionUtil = new PermissionsUtility(this.props.token);
        let parentList = permissionUtil.getParentOrgIdListForSubOrg(currentOrg.entityId);

        /*
         * TODO: Revert code used to implement GMMGO-39048 once fundingOpportunity-####-closeoutReview toggles deployed
         * fundingOpp*-closoutSubmission toggles enabled, recipient should be able to revert only if closeoutReport status
         * is not submittedToFEMA, so need both grants.status and closeoutReport status passed to getGrantActions()
         * to determine whether or not user can "Restore grant to post-award phase"
         * See GMMGO-39113
         */
        const amendmentsForGrant = _.filter(amendments, (amendment) => {
          if (amendment.grantId === grant.grantId) {
            return amendment;
          }
        });
        const gId = _.get(grant, 'grantId');
        const crStatus = _.get(this.props, 'closeoutReportStatusByGrantId', {})[gId];
        const subCrStatus = _.get(this.props, 'subCloseoutReportStatusBySubGrantId', {})[
          grant.entityId
        ];
        let inprogressSubAmendments = false;
        if (
          _.includes(toggles, 'enableProjectFormulationPostAward') &&
          grant.entityType === 'subGrant'
        ) {
          inprogressSubAmendments = this.checkForPendingSubGrantAmendments(foData, grant);
        }
        const actions = getGrantActions(
          grant,
          toggles,
          permissions,
          grantActions,
          appExtension,
          currentOrg.entityId,
          hasOrgSubOrgRelationshipForEntitySix,
          rolesToCheck,
          pageEntityType,
          parentList,
          null,
          crStatus,
          foData,
          amendmentsForGrant,
          subCrStatus,
          null,
          null,
          inprogressSubAmendments
        );
        const acceptanceDeadline = _.get(grant, 'awardAcceptanceDueDate');
        const calcDaysRemainingInApplPeriod = () => {
          let appEndDate = appExtension
            ? moment(appExtension.extendedApplicationEndDate).format('MM/DD/YYYY')
            : moment(grant.aplcnEndDate).format('MM/DD/YYYY');
          let currentDate = moment().startOf('day');
          let daysRemaining = moment(appEndDate).diff(currentDate, 'days');
          return daysRemaining > 0 ? daysRemaining : 0;
        };

        const calcPOP = () => {
          return (
            formatDateMMDDYYYY(
              _.get(grant, 'payload.periodOfPerformance.startDate', '')
            ) +
            ' - ' +
            formatDateMMDDYYYY(_.get(grant, 'payload.periodOfPerformance.endDate', ''))
          );
        };
        const displayErrorMessage = (errors) => {
          return (
            <Message
              error
              onDismiss={() => {
                this.setState({errors: null});
              }}
            >
              {errors}
            </Message>
          );
        };
        if (this.state.redirect) return <Redirect to={this.state.link} push />;

        let links = canViewPostAwardEntities(permissions) ? (
          <>
            <span>
              <Link to={`/${grantType}/${grantId}`} target="_blank">
                {grantId}
              </Link>
              &nbsp;&nbsp;
            </span>
            <Link
              to={`/${grantType}/${grantId}`}
              target="_blank"
              title={`Manage grant ${grantId}`}
            >
              {manageGrantText}
            </Link>
          </>
        ) : canViewAndContinueSubapplication(permissions) &&
          _.includes(
            retrieveAllEntityIdsFromPermissions(permissions),
            ENTITY_MAP.PROGRAM_ORGANIZATION_SUBORGANIZATION.code
          ) &&
          grantType === 'subgrant' ? (
          <>
            <span>
              <Link to={`/${grantType}/${grantId}`} target="_blank">
                {grantId}
              </Link>
              &nbsp;&nbsp;
            </span>
            <Link
              to={`/${grantType}/${grantId}`}
              target="_blank"
              title={`Manage grant ${grantId}`}
            >
              {manageGrantText}
            </Link>
          </>
        ) : (
          grantId
        );

        grant[GRANTS_CONFIG_PATHS.GRANT_LINKS] = links;
        grant[GRANTS_CONFIG_PATHS.PERIOD_PERFORMANCE_HEADER] = _.includes(
          [
            STATUS_SUBMITTED_TO_FEMA,
            STATUS_NOT_SUBMITTED,
            STATUS_PENDING_SUBMISSION,
            STATUS_PENDING_AOR_SIGNATURE,
            STATUS_INELIGIBLE,
          ],
          grant.status
        )
          ? calcDaysRemainingInApplPeriod() +
            ' ' +
            'days remaining in the application period'
          : 'PERIOD OF PERFORMANCE';

        grant[GRANTS_CONFIG_PATHS.PERIOD_PERFORMANCE] = _.includes(
          [
            STATUS_SUBMITTED_TO_FEMA,
            STATUS_NOT_SUBMITTED,
            STATUS_PENDING_SUBMISSION,
            STATUS_PENDING_AOR_SIGNATURE,
            STATUS_INELIGIBLE,
          ],
          grant.status
        )
          ? null
          : calcPOP();

        grant[GRANTS_CONFIG_PATHS.MODIFIED_STATUS] =
          grant.status === STATUS_AWARD_OFFERED
            ? PREAWARD_STATUSES[grant.status]
            : _.get(
                ASSOCIATED_ENTITY_STATUSES,
                grant.internalStatus ? grant.internalStatus : grant.status
              );

        grant[GRANTS_CONFIG_PATHS.MODIFIED_STATUS_DATE] = statusDate;

        grant[GRANTS_CONFIG_PATHS.ACCEPTANCE_DEADLINE_HEADER] =
          grant.status === STATUS_AWARD_OFFERED ? 'ACCEPTANCE DEADLINE' : null;

        grant[GRANTS_CONFIG_PATHS.MODIFIED_ACCEPTANCE_DEADLINE] =
          grant.status === STATUS_AWARD_OFFERED
            ? acceptanceDeadline
              ? moment(acceptanceDeadline).format('MM/DD/YYYY h:mm a')
              : ''
            : '';
        grant.actions = actions;
        return this.renderSections(
          config,
          grant,
          grantWriterEntityIds,
          actions,
          displayErrorMessage
        );
      });
    } else {
      return (
        <Card fluid>
          <Alert header={toastHeader} type="info">
            <p>Please try a different search criteria.</p>
          </Alert>
        </Card>
      );
    }
  }

  render() {
    return this.renderCards(this.props.data);
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    toggles: state.toggles.toggles,
    permissions: state.auth.permissions,
  };
};

export default connect(mapStateToProps)(GrantsFilterResults);
